<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_vii"></a><span class="border"><strong>T<span class="small">ABLE OF</span> C<span class="small">ONTENTS</span></strong></span></p>
<p class="toc1-b"><a href="#/xhtml/Acknowledgments"><em>Acknowledgments</em></a></p>
<p class="toc"><a href="#/xhtml/Chapter01">Chapter 1    Introduction</a></p>
<p class="toc"><a href="#/xhtml/Chapter02">Chapter 2    Context Is Your Lifeline</a></p>
<p class="toc"><span href="#/xhtml/Chapter03" title="Link target outside of Sample">Chapter 3    AAoV: A (Digestible) Mouthful</span></p>
<p class="toc"><span href="#/xhtml/Chapter04" title="Link target outside of Sample">Chapter 4    Learn to Live with Numbers or They’ll Bamboozle You</span></p>
<p class="toc"><span href="#/xhtml/Chapter05" title="Link target outside of Sample">Chapter 5    Sampling, Rankings—Often Deceptive</span></p>
<p class="toc"><span href="#/xhtml/Chapter06" title="Link target outside of Sample">Chapter 6    Filtering Out the Bull</span></p>
<p class="toc"><span href="#/xhtml/Chapter07" title="Link target outside of Sample">Chapter 7    Thought-Revoking Words</span></p>
<p class="toc"><span href="#/xhtml/Chapter08" title="Link target outside of Sample">Chapter 8    The Pitchperson Problem</span></p>
<p class="toc"><span href="#/xhtml/Chapter09" title="Link target outside of Sample">Chapter 9    Tactics: Putting NBI into Practice</span></p>
<p class="toc"><span href="#/xhtml/Chapter10" title="Link target outside of Sample">Chapter 10   Conclusions: Becoming a Wiser Citizen and Consumer</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?11983376